<template>
  <div class="screenholder__payment">
    <img
      class="screenholder__payment-img"
      src="/images/interface/loading.svg">
    <div class="screenholder__payment-title">
      We're processing your order
    </div>
    <div class="screenholder__payment-text">
      It usually takes a few seconds
    </div>
  </div>
</template>

<script>
export default {
  name: 'Payment',
};
</script>

<style lang="scss" scoped>
  .screenholder__payment {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
  }

  .screenholder__payment-title {
    margin-top: 35px;
    font-size: $text-30px;
    font-weight: 500;
  }

  .screenholder__payment-text {
    color: $color--basic-light-gray;
    font-size: $text-21px;
    margin-top: 12px;
  }
</style>
